export default "__VITE_ASSET__BJ$WKTLh__"